export default __webpack_public_path__ + "static/combined-pandemic-f15b45bab7820c09ca920531c968eb91.jpeg";